import { apiClient } from '@/services/api';
import type { ApiResponse } from '@/types/api';

import type { AddMemoToCollection, CollectionMemo, MemoCollection, MemoCollectionCreate, MemoCollectionUpdate } from './types/memos/collections';
import type { Memo } from './types/memos/types';

async function getMemosInCollection(collectionUuid: string): Promise<ApiResponse<Memo[]>> {
  return apiClient.get(`/collections/${collectionUuid}/memos`);
}

async function getMyCollections(): Promise<ApiResponse<MemoCollection[]>> {
  return apiClient.get('/collections/my');
}

async function createCollection(data: MemoCollectionCreate): Promise<ApiResponse<MemoCollection>> {
  return apiClient.post('/collections/', data);
}

async function getCollection(uuid: string): Promise<ApiResponse<MemoCollection>> {
  return apiClient.get(`/collections/${uuid}`);
}

async function updateCollection(uuid: string, data: MemoCollectionUpdate): Promise<ApiResponse<MemoCollection>> {
  return apiClient.put(`/collections/${uuid}`, data);
}

async function deleteCollection(uuid: string): Promise<ApiResponse<null>> {
  return apiClient.delete(`/collections/${uuid}`);
}

async function addMemoToCollection(collectionUuid: string, data: AddMemoToCollection): Promise<ApiResponse<CollectionMemo>> {
  return apiClient.post(`/collections/${collectionUuid}/memos`, data);
}

async function removeMemoFromCollection(collectionUuid: string, memoUuid: string): Promise<ApiResponse<null>> {
  return apiClient.delete(`/collections/${collectionUuid}/memos/${memoUuid}`);
}

async function getAccessible(): Promise<MemoCollection[]> {
  const response = await apiClient.get<MemoCollection[]>('/collections/accessible');
  if (response.success && response.data) {
    return response.data;
  }
  return [];
}



export const collections = {
  getMemosInCollection,
  getMyCollections,
  getAccessible,
  createCollection,
  getCollection,
  updateCollection,
  deleteCollection,
  addMemoToCollection,
  removeMemoFromCollection,
};
